import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  padding: 2rem;
  padding-bottom: 0;
  gap: .75rem;
  flex-direction: column;
  background: #f3f4f6;
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 1rem;
  .box--1{
    display: flex;
    width: 100%;
    height: 4rem;
    justify-content: end;
    align-items: center;
    padding: 0 1rem;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);

    button{
      outline: none;
      border: none;
      display: flex;
      width: 10rem;
      padding: 0.5rem;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;
      background-color: #1D86FF;
      color: #ffffff;
      font-size: 14px;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
      &:hover{
        opacity: 0.9;
      }
    }
  }
  .list{
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 1rem;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
    gap: 1rem;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.2);
    }
  }
`;
export const ViewCategory = styled.li`
  display: flex;
  min-width: 250px;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 4px;
  &:hover{
    cursor: pointer;
    opacity: 0.5;
  }
`;
export const NewCategory = styled.div`
  display: flex;
  width: 750px;
  height: 270px;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: space-between;
  .preview--{
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 1rem 0;
    .card {
      background-color: #ffffff;
    }
  } 
  .actions--{
    display: flex;
    width: 100%;
    height: 150px;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
    .line--{
      display: flex;
      gap: 1rem;
    }
    .action--1{
      display:flex;
      width: 50%;
      height: 30px;
      flex-direction: row;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
    }
    .action--2{
      display:flex;
      width: 25%;
      height: 30px;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      border-radius: 4px;
      color:#6d767f;
      border: 1px solid #e5e5e5;
    }
    .action--3{
      display:flex;
      width: 100%;
      height: 30px;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
    }
    input{
      border: none;
      outline:none;
      width: 100%;
      color:#495057;
      font-weight: 500;
      margin-left: 10px;
      background-color: transparent;
    }
    input[type="color"] {
      border: none;
      outline:none;
      width: 20px;
      cursor: pointer;
    }
    .save--{
      text-align: end;
    }
  }
`;
export const BtnSave = styled.button`
  height: 30px;
  width: 110px;
  outline: none;
  border:none; 
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  font-weight: bolder;
  background: #1b72d6;
  color: #ffffff;
  cursor: pointer;
  &:hover{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;
export const Tag = styled.p.attrs(props => ({
  style: {
    backgroundColor: props.color,
  },
}))`
  max-width: 50%;
  border-radius: 4px;
  padding: 0 5px;
  font-weight: bolder;
  color:#ffffff;
  background-color: #d3d3d3;
`;
export const Card = styled.div.attrs(props => ({
  style: {
    borderLeft: '8px solid' + props.color,
  },
}))`
  user-select: none;
  position: relative;
  width: 100%;
  min-height: 50px;
  max-height: 70px;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
  p{
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .category{
    position: absolute;
    display: flex;
    top: -5px;
    left: 0px;
    width: 100%;
    max-height: 11px;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.75rem;
  }
  .description{
    width: 100%;
    max-height: 55px;
    margin-top: 10px;
    overflow: hidden;
    font-size: 13px;
    font-weight: 400;
    color: #000;
    p{  
      line-height: 1.2;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      white-space: pre-wrap;
    }
  }
  .info--comments{
    display: flex;
    width: 100%;
    margin-top: 4px;
    height: 15px;
    color: #999;
    align-items: end;
    justify-content: end;
    font-size: 11px;
  }
`;
